export default __webpack_public_path__ + "static/media/c25de2668b91632c5ff38b5db5d157111582139410498.1fbefda2.webp";